import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { OverlayModule } from "@angular/cdk/overlay";
import { DsNotificationComponent } from "./ds-notification.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";
@NgModule({
  declarations: [DsNotificationComponent],
  imports: [CommonModule, OverlayModule, DsIconModule],
  exports: [DsNotificationComponent],
})
export class DsNotificationModule {}
